export default "__VITE_ASSET__B3gc3TmA__"